// 基于主题加购逻辑单独抽离出来的方法，方便在非 form 表单中调用
// 1、不绑定 HTML 使用：addToCartByJS('43489267056739', 1);
// 2、绑定 HTML 使用：<div class="add_to_cart__btn" data-variant-id="43489267056739">Add to Cart</div>

async function addToCartByJS(variantId, quantity = 1) {
  try {
    // 1. sections bundling 初始化
    let sectionsToBundle = ["variant-added"];

    // 触发 cart:prepare-bundled-sections 事件（参考 theme.js.liquid），让各个组件添加自己的 section ID
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    // 2. 创建 FormData，就像 ProductForm 那样
    const formData = new FormData();
    formData.set("id", variantId);
    formData.set("quantity", quantity);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", `${Shopify.routes.root}variants/${variantId}`);

    // 3. 调用 cart/add.js API
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    });

    if (response.ok) {
      const responseJson = await response.json();

      // 4. 获取最新购物车数据
      const cartContent = await fetch(`${Shopify.routes.root}cart.js`).then(r => r.json());

      // 5. 将 sections 数据添加到 cartContent
      cartContent["sections"] = responseJson["sections"];

      // 6. 触发 variant:add 事件（可选）
      document.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));

      // 7. 触发 cart:change 事件来更新所有相关组件
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));

      return cartContent;
    } else {
      const errorJson = await response.json();
      throw new Error(errorJson.description || '添加失败');
    }
  } catch (error) {
    console.error('加购失败:', error);

    // 触发错误事件（可选）
    document.dispatchEvent(new CustomEvent("cart:error", {
      bubbles: true,
      detail: {
        error: error.message
      }
    }));
  }
}


window.addToCartByJS = addToCartByJS;


// 防抖功能：使用特别的变量名避免冲突
window.aosuAddToCartDebounceTimers = window.aosuAddToCartDebounceTimers || new Map();
const AOSU_ADD_TO_CART_DEBOUNCE_DELAY = 300;

// 获取所有 add_to_cart__btn 并且有 data-variant-id 属性的元素
const theAllAddToCartBtns = document.querySelectorAll(".add_to_cart__btn[data-variant-id]");

// 为每个 add_to_cart__btn 元素添加点击事件
theAllAddToCartBtns.forEach(btn => {
  btn.addEventListener("click", () => {
    const variantId = btn.getAttribute("data-variant-id");
    
    // 清除该按钮之前的定时器
    if (window.aosuAddToCartDebounceTimers.has(variantId)) {
      clearTimeout(window.aosuAddToCartDebounceTimers.get(variantId));
    }
    
    // 设置新的定时器，只有最后一次点击会在延迟后执行
    const timerId = setTimeout(() => {
      addToCartByJS(variantId, 1);
      window.aosuAddToCartDebounceTimers.delete(variantId);
    }, AOSU_ADD_TO_CART_DEBOUNCE_DELAY);
    
    window.aosuAddToCartDebounceTimers.set(variantId, timerId);
  });
});